import { callFunction } from './api';
import { jsonFunction } from './function';
import Vue from 'vue';
import moment from 'moment'

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
/**
 * send loging to server
 */
var logQueue=(function(){
    var queueName="logQueue";
    // log items storage
    var queues=[];
    try{
        queues=JSON.parse( localStorage.getItem(queueName)||"[]");
    }catch(e){
        console.error("Invalid queue data",e);
    }
   
    var retryCount=5;
    function updateQueue(){
        localStorage.setItem(queueName,JSON.stringify(queues));
    }
    function enqueueLog(obj) {
   
        queues.push({data:obj,count:0});
        updateQueue();
        processLog();
    }
    function processLog( ) {
        
        if (queues.length) {
            var data=queues[0];
            if (data.count<0) data.count=0;
            var url=process.env.VUE_APP_SSO_API_POST;
            
            callFunction(url, "POST", data.data, Vue.$keycloak.token).then((res)=>{
                // debugger;
                if (res.status==0) {
                    // delete item has been log
                    queues.shift();
                } else {
                    // error ? retry it !
                   
                    queues[0].count=queues[0].count+1;
                    if (queues[0].count>retryCount) {
                        // after 'retryCount' times request failure, accept missing this log
                        queues.shift();
                    }
                }
                updateQueue();
                setTimeout(()=>processLog(),10);
            });
        }
        
    }
    // imediaete process log queue
    // processLog();
    return {push: enqueueLog }
})();




async function sleepMs(durationMs = 0) {
    await sleep(durationMs);
}

function ide_log(objectpk = '', noidung = '', thongtin = '', t_phanhoi = '', server_ = '', trangthai = '') {
    try {
        const today = new Date();
        const date = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
        const time = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}.${today.getMilliseconds()}`;
        // const ngaytao = date + ' ' + time;

        const ngaytao=moment().format("YYYY-MM-DD HH:mm:ss.SSS");
        // debugger;
        const sequence2 = Number(window.localStorage.sequence) || 1;
        window.localStorage.sequence = 1 + sequence2;

        const data = jsonFunction('ide', objectpk, ngaytao, Vue.$keycloak.idTokenParsed.preferred_username, noidung, thongtin, t_phanhoi, server_, sequence2, trangthai);
        
        const jsonString = JSON.stringify(data);
        const str2 = jsonString.replace(/[^\x00-\x7F]/g, '?');
        const jsonRequest_1 = btoa(str2);
        logQueue.push(jsonRequest_1);
        
        

        return data.body;
    } catch (err) {
        console.log(err);
    }
}

export { ide_log, sleepMs };
